class Human {
  constructor(name) {
    this.name = name;
  }

  hello() {
    console.log('My name is ' + this.name);
  }
}
export default Human;



// WEBPACK FOOTER //
// ./app/javascript/packs/human.js